export default "__VITE_ASSET__CObqmvHU__"